var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 70,
    viewBox: "0 0 10 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.235917 4.5751C-0.0799046 4.90204 -0.0783421 5.4315 0.238847 5.75683C0.556231 6.08236 1.06971 6.08075 1.38553 5.75381L5 2.01878L8.61447 5.75381C8.93029 6.08075 9.44377 6.08236 9.76115 5.75683C10.0783 5.4315 10.0799 4.90204 9.76408 4.5751L5.57168 0.243169C5.25449 -0.0823603 4.74082 -0.0807499 4.42519 0.246189L0.235917 4.5751Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.235917 65.4249C-0.0799046 65.098 -0.0783421 64.5685 0.238847 64.2432C0.556231 63.9176 1.06971 63.9192 1.38553 64.2462L5 67.9812L8.61447 64.2462C8.93029 63.9192 9.44377 63.9176 9.76115 64.2432C10.0783 64.5685 10.0799 65.098 9.76408 65.4249L5.57168 69.7568C5.25449 70.0824 4.74082 70.0807 4.42519 69.7538L0.235917 65.4249Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.ccbcc4ea02358de22968b2ed34a28f0b.svg";
export { ForwardRef as ReactComponent };